export { default, getStaticProps } from "@src/Apps/LumaScientificIntelligencePlatform";
